export const GREEN_BOLD = "#49B043"
export const GREEN_LIGHT = "#75CB70"
export const YELLOW_LIGHT = "#CDDB83"
export const YELLOW_BOLD = "#F7D442"
export const YELLOW_BROWN = "#D8B783"
export const RED_LIGHT = "#C43C26"
export const RED_BOLD = "#E61623"

export const PURPLE_LIGHT_ONE = "rgba(220, 196, 212, 0.7)"
export const PURPLE_LIGHT_TWO = "rgba(207, 171, 195, 0.66)"
export const PURPLE_LIGHT_THREE = "rgba(209, 158, 215, 0.77)"
export const PURPLE_LIGHT_FOUR = "rgba(202, 140, 209, 0.84)"
export const PURPLE_LIGHT_FIVE = "rgba(181, 89, 192, 0.67)"
export const PURPLE_LIGHT_SIX = "rgba(165, 49, 179, 0.8)"
export const PURPLE_LIGHT_SEVEN = "#A531B3"
